"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getValueByField = void 0;
const json_1 = require("../commonUtils/json");
const field_1 = require("../interfaces/field");
const getObjectById_1 = require("./getObjectById");
/**
 * Returns the value of a field from a given data object based on the field's configuration.
 * @param field - The field configuration object.
 * @param data - The data object to retrieve the field value from.
 * @param _id - Optional. The ID of the object to retrieve the field value from, if the field is a child of a list field.
 * @returns The value of the field from the data object, or null if the field is not found.
 */
const getValueByField = (field, data, _id) => {
    const key = (0, json_1.getJsonKeyFromField)(field);
    if (_id) {
        const obj = (0, getObjectById_1.getObjectById)(_id, data);
        if (obj?.hasOwnProperty(key)) {
            return obj[key];
        }
        else {
            if (field.field_type === field_1.FieldTypes.list) {
                return [];
            }
            if (field.field_type === field_1.FieldTypes.group) {
                return {};
            }
        }
        return '';
    }
    if (field.parent === null) {
        if (data && data.hasOwnProperty(key))
            return data[key];
        if (field.field_type === field_1.FieldTypes.list) {
            return [];
        }
        if (field.field_type === field_1.FieldTypes.group) {
            return {};
        }
        return '';
    }
};
exports.getValueByField = getValueByField;
